export async function validateResumePdf(file) {
  if (!/\.pdf$/i.test(file.name) || (file.type && file.type !== 'application/pdf')) {
    throw new Error('Please upload a PDF. In Word, choose Save As or Export, then PDF.');
  }
  if (!file.size || file.size > 10 * 1024 * 1024) {
    throw new Error('Choose a PDF that is not empty and is 10 MB or smaller.');
  }
  const header = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('This file could not be read. Please choose it again.'));
    reader.readAsText(file.slice(0, 5));
  });
  if (header !== '%PDF-') throw new Error('This file does not appear to be a PDF. Export it as PDF instead of renaming it.');
}

// Each upload gets a separate object so existing applications keep their PDF.
// Keep legacy objects too: applications may still reference those paths.
export async function saveResumeVersion(supabase, file) {
  await validateResumePdf(file);
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.user) throw new Error('Please sign in again before uploading your resume.');
  // The existing private-bucket ownership policy reads the ID before the first dot.
  const path = `${session.user.id}.${crypto.randomUUID()}.pdf`;
  const { error: uploadError } = await supabase.storage
    .from('resumes').upload(path, file, { upsert: false, contentType: 'application/pdf', cacheControl: '0' });
  if (uploadError) throw new Error('Your resume could not be uploaded. Please try again.');
  const { data: saved, error: profileError } = await supabase.from('profiles').update({
    resume_url: path,
    resume_name: file.name,
  }).eq('id', session.user.id).select('id').single();
  // Do not delete on an uncertain save: the server may have committed before
  // the response was lost. An unreferenced private file is safer than a broken PDF.
  if (profileError || !saved) throw new Error('The file uploaded, but the profile update could not be confirmed. Please try again.');
  return { path, name: file.name };
}
